//#region src/extensions/line-height-extension/constants.ts
var e = "lineHeight", t = ["paragraph", "heading"];
//#endregion
export { e as LINE_HEIGHT_ATTRIBUTE, t as LINE_HEIGHT_TYPES };
